import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { secureStorage } from '../lib/secure-storage';

interface BabyProfile {
  name: string;
  dob: string;
  familySize: number;
  city: string;
  caregiverName?: string;
}

interface AppState {
  hasOnboarded: boolean;
  babyProfile: BabyProfile | null;
  skipBabyMode: boolean;
  authUser: any | null;
  userProfile: any | null;
  savedShoppingPlan: any | null;
  shoppingCheckedItems: string[];
  shoppingCheckedSteps: string[];
  shoppingSearchQuery: string;
  shoppingActiveTab: 'spesifik' | 'multi';
  shoppingDays: number;
  shoppingTempatBelanja: string;
  savedBudgetPlan: any | null;
  budgetAmount: number;
  budgetDays: number;
  setHasOnboarded: (value: boolean) => void;
  setBabyProfile: (profile: BabyProfile) => void;
  setSkipBabyMode: (value: boolean) => void;
  setAuthUser: (user: any | null) => void;
  setUserProfile: (profile: any | null) => void;
  setSavedShoppingPlan: (plan: any | null) => void;
  setShoppingCheckedItems: (items: string[]) => void;
  setShoppingCheckedSteps: (steps: string[]) => void;
  setShoppingSearchQuery: (query: string) => void;
  setShoppingActiveTab: (tab: 'spesifik' | 'multi') => void;
  setShoppingDays: (days: number) => void;
  setShoppingTempatBelanja: (tempat: string) => void;
  setSavedBudgetPlan: (plan: any | null) => void;
  setBudgetAmount: (amount: number) => void;
  setBudgetDays: (days: number) => void;
}

export const useStore = create<AppState>()(
  persist(
    (set) => ({
      hasOnboarded: false,
      babyProfile: null,
      skipBabyMode: false,
      authUser: null,
      userProfile: null,
      savedShoppingPlan: null,
      shoppingCheckedItems: [],
      shoppingCheckedSteps: [],
      shoppingSearchQuery: '',
      shoppingActiveTab: 'spesifik',
      shoppingDays: 3,
      shoppingTempatBelanja: 'Pasar Tradisional',
      savedBudgetPlan: null,
      budgetAmount: 100000,
      budgetDays: 3,
      setHasOnboarded: (value) => set({ hasOnboarded: value }),
      setBabyProfile: (profile) => set({ babyProfile: profile }),
      setSkipBabyMode: (value) => set({ skipBabyMode: value }),
      setAuthUser: (user) => set({ authUser: user }),
      setUserProfile: (profile) => set({ userProfile: profile }),
      setSavedShoppingPlan: (plan) => set({ savedShoppingPlan: plan }),
      setShoppingCheckedItems: (items) => set({ shoppingCheckedItems: items }),
      setShoppingCheckedSteps: (steps) => set({ shoppingCheckedSteps: steps }),
      setShoppingSearchQuery: (query) => set({ shoppingSearchQuery: query }),
      setShoppingActiveTab: (tab) => set({ shoppingActiveTab: tab }),
      setShoppingDays: (days) => set({ shoppingDays: days }),
      setShoppingTempatBelanja: (tempat) => set({ shoppingTempatBelanja: tempat }),
      setSavedBudgetPlan: (plan) => set({ savedBudgetPlan: plan }),
      setBudgetAmount: (amount) => set({ budgetAmount: amount }),
      setBudgetDays: (days) => set({ budgetDays: days }),
    }),
    {
      name: 'satu-wajan-storage',
      storage: createJSONStorage(() => secureStorage),
    }
  )
);
